<template>
  <div class="z2-info-storage d-flex flex-column" style="height: 100%;">
    <!-- Header -->
    <div
      class="d-flex align-items-center justify-content-between px-2 border-bottom"
      style="height: 56px"
    >
      <div class="pointer" @click="$emit('close');">
        <IconV2 name="v2-arrow2_left" size="24px" />
      </div>
      <div class="font-16 fw-500 flex-1 text-center">
        <span class="me-3">Nhóm chung ({{ conversations.length }})</span>
      </div>
    </div>

    <!-- List -->
    <div class="conversation-list flex-1" style="overflow-y: auto; width: 100%;">
      <div
        v-for="item in conversations"
        :key="item.id"
        class="conversation-item"
        @click="openGroupInfo(item)"
      >
        <div class="avatar-group">
          <img :src="item.avatar" class="avatar" />
        </div>

        <div class="conversation-name">
          {{ item.swName || item.toName }}
        </div>
      </div>
    </div>

    <!-- Footer (dính đáy) -->
    <!-- <div class="border-top" style="padding: 12px">
      <button class="add-btn w-100">
        👥 Thêm vào nhóm
      </button>
    </div> -->

    <el-dialog
      :visible.sync="showProfile"
      width="360px"
      title="Thông tin nhóm"
      :destroy-on-close="true">
      <GroupInfoPopup
        :members="members.length"
        :avatar="conversation.avatar || '/assets/images/no-avatar.png'"
        :name="conversation.toName"
        :closeGroupInfoPopup="showProfile"
        :idConversationGroup="conversation" />
    </el-dialog>
  </div>
</template>


<script>
import GroupInfoPopup from '../../components/GroupInfoPopup.vue';
export default {
  name: 'ConversationList',
  props: {
    conversations: {
      type: Array,
      required: true
    }
  },
  components: {
    GroupInfoPopup
  },
  data() {
    return {
      showProfile: false,
      conversation: {},
      members: []
    };
  },
  methods: {
    openGroupInfo(item) {
      if (!item.group) return

      this.conversation = item
      this.showProfile = true
    }
  }
}
</script>

<style scoped>
.conversation-list {
  width: 280px;
  background: #fff;
  border-right: 1px solid #eee;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.conversation-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
}

.conversation-item:hover {
  background: #f5f6f7;
}

/* Avatar group */
.avatar-group {
  position: relative;
  width: 60px;
  height: 32px;
}

.avatar {
  position: absolute;
  top: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #fff;
  background: #eee;
}

/* Badge */
.badge {
  position: absolute;
  right: -4px;
  bottom: -4px;
  background: #e4e6eb;
  color: #333;
  font-size: 12px;
  padding: 0 6px;
  border-radius: 10px;
  line-height: 18px;
}

/* Name */
.conversation-name {
  flex: 1;
  font-size: 14px;
  color: #050505;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Footer */
.add-group {
  margin-top: auto;
  padding: 10px;
  border-top: 1px solid #eee;
}

.add-btn {
  width: 100%;
  padding: 8px;
  border: none;
  background: #e4e6eb;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}

.add-btn:hover {
  background: #d8dadf;
}

.z2-info-storage {
  position: absolute;
  width: 300px;
  height: 100vh;
  top: 0;
  z-index: 3000;
  background-color: white;
}
</style>
